import { generateIconComponent } from './icons.utils';

export const HamburgerSolidIcon = generateIconComponent({
    name: 'HamburgerSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <>
            <rect fill="currentColor" height="3" rx="1.5" width="24" y="3.5" />
            <rect fill="currentColor" height="3" rx="1.5" width="24" y="10.5" />
            <rect fill="currentColor" height="3" rx="1.5" width="24" y="17.5" />
        </>
    ),
});
